export default "__VITE_ASSET__$fuQIdtY__"